module.exports = __webpack_public_path__ + "img/Frame2364.446eaa4d.png";